"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelionBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const AresHandler_1 = require("../../ares/AresHandler");
const AutomaHandler_1 = require("../../automa/AutomaHandler");
const constants_1 = require("../../constants");
const GameSetup_1 = require("../../GameSetup");
class HelionBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.HELION_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU04',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Increase temperature 1 step. Gain 1 TR.', (eb) => {
                            eb.empty().startAction.temperature(1).nbsp().tr(1);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        const neutral = GameSetup_1.GameSetup.neutralPlayerFor(game.id);
        game.automaBotVictoryPointsBreakdown.terraformRating += 2;
        if (game.getTemperature() < constants_1.MAX_TEMPERATURE) {
            AutomaHandler_1.AutomaHandler.increaseTemperature(game, 1);
            game.temperatureSilverCubeBonusMC = 0;
            AutomaHandler_1.AutomaHandler.checkForTemperatureBonusOcean(game, neutral);
            AresHandler_1.AresHandler.ifAres(game, (aresData) => {
                AresHandler_1.AresHandler.onTemperatureChange(game, aresData);
            });
        }
        game.log('${0} action: Increase temperature 1 step and gain 1 TR', (b) => b.card(this));
        return undefined;
    }
}
exports.HelionBot = HelionBot;
//# sourceMappingURL=HelionBot.js.map